import { React } from 'react'

const Analytics = () => {
  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> Analytics </h3>
      </div>
      <div className="card">
        <div className="card-body">
          <iframe
            className="d-block"
            width="100%"
            height="650px"
            src="https://lookerstudio.google.com/embed/reporting/53adf2c3-b0ef-4d64-9c37-35076650df13/"
            style={{ border: 0 }}
            allowFullScreen
            // sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            title="Looker Studio Report"
          ></iframe>
        </div>
      </div>
    </div>
  )
}
export default Analytics
